import React from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { useI18n } from '../contexts/I18nContext';

/**
 * Date-range filter block. Shows two paired date inputs (from / to) for
 * "Arrival at port" and "Delivery". Stateless — owner controls values.
 */
export function DateFiltersPanel({ filters, onFilterChange, onClear }) {
  const { t } = useI18n();
  return (
    <div className="mt-4 pt-4 border-t border-border">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <Label className="text-sm font-medium">{t('shipments.arrivalAtPort')}</Label>
          <p className="text-xs text-muted-foreground mb-2">{t('shipments.arrivalAtPortHint')}</p>
          <div className="flex gap-2">
            <Input type="date" value={filters.eta_arribo_from} onChange={(e) => onFilterChange('eta_arribo_from', e.target.value)} className="text-sm" data-testid="filter-arribo-from" />
            <Input type="date" value={filters.eta_arribo_to} onChange={(e) => onFilterChange('eta_arribo_to', e.target.value)} className="text-sm" data-testid="filter-arribo-to" />
          </div>
        </div>
        <div>
          <Label className="text-sm font-medium">{t('shipments.delivery')}</Label>
          <p className="text-xs text-muted-foreground mb-2">{t('shipments.deliveryHint')}</p>
          <div className="flex gap-2">
            <Input type="date" value={filters.entrega_from} onChange={(e) => onFilterChange('entrega_from', e.target.value)} className="text-sm" data-testid="filter-entrega-from" />
            <Input type="date" value={filters.entrega_to} onChange={(e) => onFilterChange('entrega_to', e.target.value)} className="text-sm" data-testid="filter-entrega-to" />
          </div>
        </div>
      </div>
      <div className="flex justify-end mt-3">
        <Button variant="ghost" size="sm" onClick={onClear}>{t('shipments.clearDates')}</Button>
      </div>
    </div>
  );
}
